/* unplugin-vue-components disabled */import script from "./RefundModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./RefundModal.vue?vue&type=script&setup=true&lang=ts"

import "./RefundModal.vue?vue&type=style&index=0&id=3b0c8745&scoped=true&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b0c8745"]])

export default __exports__